<template>
    <section v-if="props.modelValue" class="modal">
        <article class="modal__content">
            <h4 class="modal__title">Agregar Módulo</h4>
            <form class="modal__form">
                <span>
                    <input class="basic-slide" id="moduleName" type="text" placeholder="Escribe el nombre del Módulo" /><label
                        for="moduleName" autocomplete="off">Módulo</label>
                </span>
                <div class="modal__separator">
                    <button type="submit" class="save-button">Guardar</button>
                </div>
            </form>

            <button class="modal__close" @click="closeModal">&times;</button>
        </article>
    </section>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    modelValue: Boolean
});

const emit = defineEmits(['update:modelValue']);

const closeModal = () => {
    emit('update:modelValue', false);
};
</script>